import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { ShowIf } from 'components/utils';
import TextTruncate from 'react-text-truncate';

class RowItemLetterTable extends React.Component {

  userAddress() {
    let user = this.props.item.listNguoiDungDon.length > 0 ? this.props.item.listNguoiDungDon[0] : [];
    let userAddress = '';
    if (user.diaChi) {
      userAddress = userAddress + user.diaChi
    }
    if (user.toThon && userAddress == '') {
      userAddress = userAddress + user.toThon
    } else if (user.toThon && userAddress != '') {
      userAddress = userAddress + ", " + user.toThon
    }
    if (user.phuongXaCongDan && userAddress == '') {
      userAddress = userAddress + user.phuongXaCongDan.ten
    } else if (user.phuongXaCongDan && userAddress != '') {
      userAddress = userAddress + ", " + user.phuongXaCongDan.ten
    }
    if (user.quanHuyenCongDan && userAddress == '') {
      userAddress = userAddress + user.quanHuyenCongDan.ten
    } else if (user.quanHuyenCongDan && userAddress != '') {
      userAddress = userAddress + ", " + user.quanHuyenCongDan.ten
    }
    if (user.tinhThanhCongDan && userAddress == '') {
      userAddress = userAddress + user.tinhThanhCongDan.ten
    } else if (user.tinhThanhCongDan && userAddress != '') {
      userAddress = userAddress + ", " + user.tinhThanhCongDan.ten
    }

    return userAddress
  }

  handleClickDetail() {
    this.props.onClickDetail(this.props.item, true);
  }

  render() {
    let donDate = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
    let donTime = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('HH:mm') : '';
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{donDate}</li>
            <li>{donTime}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li className="txt-bold">{this.props.item.listNguoiDungDon.length ? this.props.item.listNguoiDungDon[0].hoVaTen : ''}</li>
            <li>{this.userAddress()}</li>
            <li>{this.props.item.listNguoiDungDon.length ? this.props.item.listNguoiDungDon[0].soDienThoai : ''}</li>
          </ul>
        </td>
        <td className="list-items-table">
          <ul className="list-items-table">
            <li>
              <Link className="txt-underline" onClick={this.handleClickDetail.bind(this)} >
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={this.props.item.noiDung}
                />
              </Link>
            </li>
            <ShowIf condition={this.props.type == 'DON_TRE_HAN'}>
              <li className='txt-danger'>{("Đã trễ: ") + (this.props.item.treHanGiaiQuyetDonInfo ? this.props.item.treHanGiaiQuyetDonInfo.value : '') + (' ngày') }</li>
            </ShowIf>
          </ul>
        </td>
      </tr>
    );
  }
}

export default RowItemLetterTable;


// WEBPACK FOOTER //
// ./src/components/modules/home/dataTable/RowItemLetterTable.jsx